import { memo } from "react";
import { apiNiches } from "@/common/services";
import { DUPLICATE_CODE, CREATE_NICHE_FIELDS } from "./constants";
import { AxiosError } from "axios";
import { IErrorData } from "@/common/services/types";
import { NicheForm } from "@/components/popups/NicheForm";
import { showNotification } from "@/components/notifications/Notifications";
import { useNavigate } from "react-router";
import { routes } from "@/common/utils/routes";
import { INicheForm } from "@/components/popups/NicheForm/NicheForm";
import { useNicheFormState } from "../NicheForm/hooks/useNicheFormState";

interface ICreateFormProps {
  handleGoSuccess: () => void;
}

export const CreateForm = memo((props: ICreateFormProps) => {
  const { handleGoSuccess } = props;
  const navigate = useNavigate();
  const {
    avatarTicketId,
    bannerTicketId,
    prefOptions,
    tags,
    onSetPreferences,
    handleAvatarTicketId,
    handleBannerTicketId,
    onTagsChange
  } = useNicheFormState();

  const getError = (error: AxiosError<IErrorData>) => {
    const e = (error as AxiosError<IErrorData>).response?.data?.error;

    if (e?.code === DUPLICATE_CODE) {
      if (e.public && e.niche_id) {
        showNotification({
          title: `A niche named ${e.niche_id} already exists`,
          description: "Click the button below to see it",
          variant: "info",
          actionButton: {
            title: "Go to the niche",
            onClick: () => navigate(routes.niche(e.niche_id as string))
          },
          toastOptions: {
            duration: 10000
          }
        });
        return;
      } else {
        showNotification({
          title: e.message,
          variant: "error"
        });

        return;
      }
    }

    showNotification({
      title: "Error submitting the niche, please try again later.",
      variant: "error"
    });
  };

  const onSubmit = async (data: INicheForm) => {
    try {
      await apiNiches.createNiche({
        name: data.name.replace(/\b\w/g, char => char.toUpperCase()),
        description: data.description,
        rules: "Rule 1: No spam Rule 2: Follow site-wide guidelines Rule 3: Stay on Theme",
        profile_image: avatarTicketId,
        banner: bannerTicketId,
        preferences: prefOptions.filter((pref) => pref.isChecked).map((pref) => pref.name),
        tags: tags
      });
      handleGoSuccess();
    } catch (e) {
      console.error(e);
      getError(e as AxiosError<IErrorData>);
    }
  };

  return (
    <NicheForm
      onSubmit={onSubmit}
      handleAvatarTicketId={handleAvatarTicketId}
      handleBannerTicketId={handleBannerTicketId}
      onSetPreferences={onSetPreferences}
      onTagsChange={onTagsChange}
      tags={tags}
      avatarTicketId={avatarTicketId}
      bannerTicketId={bannerTicketId}
      fields={CREATE_NICHE_FIELDS}
      prefOptions={prefOptions}
      btnTitle="Submit"
    />
  );
});

